import * as React from "react";
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { TableHead, styled, useMediaQuery, useTheme } from "@mui/material";
import { AddAction } from "./AddAction";
import "../../../../../../../../utils/number_extensions";
import { ISubTransaction } from "./SubTransactionsField";

const HeaderTableCell = styled(TableCell)(({theme}) => ({
    fontWeight: 'bold',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    padding: 5,

    [theme.breakpoints.down('md')]: {
        padding: 2,
    },
}));

const DescriptionHeaderTableCell = styled(HeaderTableCell)(({theme}) => ({
    textAlign: 'left',
}));

interface IDataTableHeaderProps {
    onAdd(value: ISubTransaction): void;
}

export const DataTableHeader = ({onAdd}: IDataTableHeaderProps) => {
    const isSmallScreen = useMediaQuery(useTheme().breakpoints.down('md'));

    return (
        <TableHead>
            <TableRow>
                <HeaderTableCell>
                    <AddAction onChange={onAdd} />
                </HeaderTableCell>
                <HeaderTableCell>Date</HeaderTableCell>
                <HeaderTableCell>Amount</HeaderTableCell>
                <DescriptionHeaderTableCell>{isSmallScreen ? 'Desc.' : 'Description'}</DescriptionHeaderTableCell>
            </TableRow>
        </TableHead>
    );
}
